
import { useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { uxApi } from "./api";


export const useNotificationChoices = (choice) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.choices(choice),
    () => uxApi.getNotificationChoices(choice),
  );
};

